import { Stack, Typography } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import React from "react";

type Props = {};

const Cancellation = (props: Props) => {
  return (
    <Stack 
      direction="column" 
      alignItems="flex-start" 
      p={2} 
      spacing={3}
      sx={{ maxWidth: 1100, margin: "0 auto", lineHeight: 1.7 }}
>
      <Typography variant="h5" textAlign="justify">
        Cancellation & Refund Policy
      </Typography>
      <Typography variant="body1" textAlign="justify">
        No cancellations and refunds are entertained for the payments made to
        Modern College of Physiotherapy.
      </Typography>
      {/* <ul>
        <Typography variant="body1" textAlign="justify" fontWeight={'bold'}>
          Please note the following important points:
        </Typography>
        <Typography variant="body1" textAlign="justify">
          <ArrowForwardIosIcon
            sx={{
              color: "text.secondary",
              fontSize: "small",
              minWidth: "fit-content",
              pr: 0.5
            }}
          />
          All transactions are final and non-refundable. Please review your payment
          details carefully before proceeding.
        </Typography>
        <Typography variant="body1" textAlign="justify">
          <ArrowForwardIosIcon
            sx={{
              color: "text.secondary",
              fontSize: "small",
              minWidth: "fit-content",
              pr: 0.5
            }}
          />
          In case of any issues related to payment or billing, please contact us
          within 24 hours of the transaction.
        </Typography>
        <Typography variant="body1" textAlign="justify">
          <ArrowForwardIosIcon
            sx={{
              color: "text.secondary",
              fontSize: "small",
              minWidth: "fit-content",
              pr: 0.5
            }}
          />
          Refunds are not provided except in the case of technical errors
          where the service has not been provided due to a fault on our end.
        </Typography>
        <Typography variant="body1" textAlign="justify">
          <ArrowForwardIosIcon
            sx={{
              color: "text.secondary",
              fontSize: "small",
              minWidth: "fit-content",
              pr: 0.5
            }}
          />
          For further clarification or inquiries, feel free to contact our support
          team at the provided contact information.
        </Typography>
      </ul> */}
    </Stack>
  );
};

export default Cancellation;
